var _defs, _g, _title;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3803",
    viewBox: "0 0 512 512",
    height: 512,
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3807"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3792"
  }, /*#__PURE__*/React.createElement("title", {
    id: "title3789"
  }, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: -1,
    y: -1,
    width: 582,
    height: 402,
    id: "canvas_background"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.97184184,0,0,0.93307064,7.2084897,13.133919)",
    style: {
      fill: "#9d2c80",
      fillOpacity: 1
    },
    id: "g3801"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", {
    id: "title3794"
  }, "Layer 1")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9d2c80",
      fillOpacity: 1
    },
    d: "M 437.78446,42.592011 H 74.215548 c -28.855524,0 -52.331484,23.47596 -52.331484,52.331484 V 320.5713 c 0,28.85552 23.47596,52.33148 52.331484,52.33148 H 208.74788 l -12.54129,63.43153 H 155.5463 c -9.13343,0 -16.53685,7.40341 -16.53685,16.53684 0,9.13343 7.40342,16.53685 16.53685,16.53685 10.44747,0 190.40015,0 200.90741,0 9.13343,0 16.53685,-7.40342 16.53685,-16.53685 0,-9.13343 -7.40342,-16.53684 -16.53685,-16.53684 h -40.66029 l -12.54129,-63.43153 h 134.53233 c 28.85553,0 52.33149,-23.47596 52.33149,-52.33148 V 94.923495 C 490.11467,66.067971 466.63999,42.592011 437.78446,42.592011 Z M 282.07861,436.33303 h -52.15848 l 12.54129,-63.43152 h 27.07463 z m 174.96237,-115.763 c 0,10.61919 -8.63987,19.25779 -19.25779,19.25779 -12.75373,0 -341.633424,0 -363.567642,0 -10.619199,0 -19.257793,-8.6386 -19.257793,-19.25779 V 94.923495 c 0,-10.619199 8.638594,-19.257793 19.257793,-19.257793 H 437.78446 c 10.6192,0 19.25779,8.638594 19.25779,19.257793 V 320.57003 Z",
    id: "svg_3",
    stroke: "null"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4647",
    d: "m 56.89881,345.98301 c -5.805027,-2.07033 -8.797638,-4.83341 -11.419991,-10.54409 -2.033017,-4.42728 -2.141047,-10.80777 -2.165355,-127.88958 -0.0212,-102.0893 0.249576,-123.872922 1.57835,-126.978467 1.93969,-4.533348 7.114712,-9.560488 11.577478,-11.246637 2.269724,-0.857561 63.703838,-1.239052 199.533398,-1.239052 164.05389,0 196.86902,0.263164 200.00261,1.603934 4.53334,1.93969 9.56049,7.114712 11.24664,11.577478 0.84701,2.241813 1.23905,42.337534 1.23905,126.724644 0,101.6245 -0.28088,124.11747 -1.58902,127.24825 -2.02589,4.84868 -7.74691,9.6728 -13.30014,11.21509 -2.90332,0.80634 -68.31115,1.1885 -198.29487,1.15858 -160.569359,-0.037 -194.727884,-0.3176 -198.40815,-1.63015 z",
    style: {
      fill: "#183333",
      fillOpacity: 1,
      strokeWidth: 1.16494
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot4649",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 160,
      lineHeight: 1.25,
      fontFamily: "Manjari",
      InkscapeFontSpecification: "'Manjari Bold'",
      letterSpacing: "-6.65999985px",
      wordSpacing: 0,
      fill: "#f2f2f2",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(1.2749539,0,0,1.2667876,104.78986,-33.323606)",
    "aria-label": "GS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path840",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 160,
      fontFamily: "Manjari",
      InkscapeFontSpecification: "'Manjari Bold'",
      letterSpacing: "-6.65999985px",
      fill: "#f2f2f2"
    },
    d: "m -5.5917969,187.34766 c 0,32.42187 23.9062499,55.46875 56.7968749,55.46875 13.359375,0 25.625,-3.59375 35.625,-7.57813 2.8125,-1.01562 4.921875,-4.0625 4.921875,-7.03125 v -0.0781 l -0.3125,-39.92188 c 0,-4.29687 -3.59375,-7.73437 -7.8125,-7.73437 H 51.986328 c -4.296875,0 -7.8125,3.51562 -7.8125,7.8125 0,4.29687 3.515625,7.8125 7.8125,7.8125 h 23.828125 l 0.234375,26.64062 c -7.265625,2.34375 -16.484375,4.375 -25.390625,4.375 -24.375,0 -40.7812499,-16.71875 -40.7812499,-40.07812 0,-22.73438 17.4218749,-43.04688 41.7187499,-43.04688 10.703125,0 21.328125,3.51563 29.453125,9.0625 1.328125,0.9375 3.046875,1.48438 4.609375,1.48438 4.296875,0 7.8125,-3.51563 7.8125,-7.73438 0,-2.34375 -1.40625,-4.92187 -3.359375,-6.25 -11.015625,-7.8125 -23.359375,-12.26562 -38.90625,-12.26562 -33.75,0 -56.7968749,28.35937 -56.7968749,59.0625 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path842",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: 160,
      fontFamily: "Manjari",
      InkscapeFontSpecification: "'Manjari Bold'",
      letterSpacing: "-6.65999985px",
      fill: "#f2f2f2"
    },
    d: "m 146.26382,128.44141 c -20.625,0 -44.29687,11.79687 -44.29687,33.4375 0,12.34375 7.96875,20.15625 16.25,24.29687 14.53125,7.34375 33.4375,5.70313 48.28125,12.03125 4.375,1.875 8.82812,5.46875 8.82812,10.9375 0,12.96875 -16.01562,18.82813 -29.21875,18.82813 -14.14062,0 -25.9375,-6.48438 -30.46875,-17.03125 -1.09375,-2.65625 -4.29687,-4.76563 -7.1875,-4.76563 -4.29687,0 -7.8125,3.51563 -7.8125,7.8125 0,0.9375 0.3125,2.26563 0.70313,3.125 6.95312,16.17188 24.375,26.48438 44.76562,26.48438 19.92188,0 44.92188,-11.48438 44.92188,-34.45313 0,-13.20312 -9.14063,-21.32812 -18.35938,-25.3125 -14.60937,-6.25 -33.90625,-4.84375 -47.42187,-11.64062 -3.82813,-1.95313 -7.57813,-5.54688 -7.57813,-10.3125 0,-11.875 16.79688,-17.8125 28.59375,-17.8125 12.10938,0 21.875,5.70312 25.85938,14.6875 1.09375,2.57812 4.375,4.6875 7.1875,4.6875 4.29687,0 7.8125,-3.51563 7.8125,-7.8125 0,-0.9375 -0.3125,-2.34375 -0.70313,-3.20313 -6.25,-14.14062 -22.1875,-23.98437 -40.15625,-23.98437 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot4661",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Dyuthi",
      InkscapeFontSpecification: "Dyuthi",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "#999999",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0.74736193,0,0,1.8076399,14.810743,-158.96031)",
    "aria-label": "<"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path891",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 160,
      fontFamily: "Dyuthi",
      InkscapeFontSpecification: "Dyuthi",
      fill: "#999999"
    },
    d: "m 119.50977,172.08789 q 0,-3.75 -2.57813,-6.25 -2.5,-2.57812 -6.25,-2.73437 -1.71875,-0.15625 -3.51562,0.70312 l -59.062504,25.54688 q -6.875,2.96875 -6.875,10.54687 0,7.42188 6.875,10.39063 l 59.062504,25.39062 q 1.79687,0.85938 3.51562,0.85938 3.75,0 6.25,-2.57813 2.57813,-2.57812 2.57813,-6.5625 0,-6.01562 -5.54688,-8.28125 l -47.734374,-19.375 47.734374,-19.375 q 5.54688,-2.34375 5.54688,-8.28125 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text4713",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "54.59805679px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "#999999",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.36495137
    },
    transform: "scale(1.0585663,0.94467393)",
    "aria-label": "/"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "181.99351501px",
      fontFamily: "'Phetsarath OT'",
      InkscapeFontSpecification: "'Phetsarath OT'",
      fill: "#999999",
      strokeWidth: 1.36495137
    },
    d: "m 321.99985,282.97447 37.76721,-134.71786 h 12.79642 l -37.67835,134.71786 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot4661-5",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 40,
      lineHeight: 1.25,
      fontFamily: "Dyuthi",
      InkscapeFontSpecification: "Dyuthi",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      textAnchor: "start",
      fill: "#999999",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(-0.74736193,0,0,1.8076399,485.26655,-158.96031)",
    "aria-label": "<"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: 160,
      fontFamily: "Dyuthi",
      InkscapeFontSpecification: "Dyuthi",
      fill: "#999999"
    },
    d: "m 119.50977,172.08789 q 0,-3.75 -2.57813,-6.25 -2.5,-2.57812 -6.25,-2.73437 -1.71875,-0.15625 -3.51562,0.70312 l -59.062504,25.54688 q -6.875,2.96875 -6.875,10.54687 0,7.42188 6.875,10.39063 l 59.062504,25.39062 q 1.79687,0.85938 3.51562,0.85938 3.75,0 6.25,-2.57813 2.57813,-2.57812 2.57813,-6.5625 0,-6.01562 -5.54688,-8.28125 l -47.734374,-19.375 47.734374,-19.375 q 5.54688,-2.34375 5.54688,-8.28125 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.54b9f66f90d50f916525ca76dd07f454.svg";
export { ForwardRef as ReactComponent };